import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom/dist";
import VendorSalesStatistics from "routes/vendor/VendorSalesStatistics";
import style from "./StoreManagementDetail.module.css";
import Center from "layouts/wrapper/Center";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Container from "layouts/container/Container";
import { requester } from "App";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import clsx from "classnames";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Seperator from "components/Separator";

function StoreManagementDetail(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const [data, setData] = useState();
    const [kiosks, setKiosks] = useState([]);
    const [devices, setDevices] = useState([]);
    const [isMounted, setMounted] = useState(false);
    const [salesOverview, setSalesOverview] = useState();
    const { isMobile } = useContext(BrowserDetectContext);

    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            let storeData = { id: data?.id }
            requester.getVendorStoreSalesOverview(storeData, (result) => {
                setSalesOverview(result.data);
            })
        }
    }, [isMounted])
    useEffect(() => {
        if (props.data) {
            console.log("props.data : ",props.data)
            setData(props.data);
        }
    }, [props])
    useEffect(() => {
        if (location.state) {
            setData(location.state.data);
        }
    }, [location])


    useEffect(() => {
        if (data) {
            // machines 배열을 순회하며 키오스크와 기기를 분류
            const kiosksTemp = data.machines.filter(machine => machine.orderNo === 1 || machine.orderNo === 2);
            const devicesTemp = data.machines.filter(machine => machine.orderNo !== 1 && machine.orderNo !== 2);
            setKiosks(kiosksTemp);
            setDevices(devicesTemp);
            console.log("devicesTemp : ", devicesTemp)
        }

    }, [data])

    const handleManage = (data) => {
        navigate(`/admin/store/management/detail/${data.id}`, { state: { data: data } })
    };

    const onStockManagemanetClick = () => {
        navigate(`/admin/store/management/detail/${data.id}/stock`, { state: { data: data } })
    }

    return (
        <div className={style.storeDetailContainer}>
            {data && (
                <div className={style.storeContent}>
                    <div className={style.storeHeader}>
                        <HorizontalFlex gap={10} alignItems="center">
                            <FlexChild>
                                <P size={20} weight={600}>{data.storeName}</P>
                            </FlexChild>
                            <FlexChild justifyContent={"flex-end"}>
                                <button 
                                    onClick={onStockManagemanetClick} 
                                    className={style.stockManageButton}
                                >
                                    <span className={style.buttonText}>재고관리</span>
                                    <span className={style.buttonIcon}>
                                        <FontAwesomeIcon icon={fas["faBoxOpen"]} />
                                    </span>
                                </button>
                            </FlexChild>
                        </HorizontalFlex>
                    </div>

                    {data.confirmYn && (
                        <div className={style.salesStatsSection}>
                            <HorizontalFlex gap={10}>
                                <div className={clsx(style.statCard, { [style.mobile]: isMobile })}>
                                    <Center>
                                        <P>일일 매출액</P>
                                        <P color={"darkcyan"}>{salesOverview ? salesOverview.todayTotalPrice.toLocaleString() : 0} 원</P>
                                    </Center>
                                </div>
                                <div className={clsx(style.statCard, { [style.mobile]: isMobile })}>
                                    <Center>
                                        <P>금주 매출액</P>
                                        <P color={"darkcyan"}>{salesOverview ? salesOverview.thisWeekTotalPrice.toLocaleString() : 0}원</P>
                                    </Center>
                                </div>
                                <div className={clsx(style.statCard, { [style.mobile]: isMobile })}>
                                    <Center>
                                        <P>당월 매출액</P>
                                        <P color={"darkcyan"}>{salesOverview ? salesOverview.thisMonthTotalPrice.toLocaleString() : 0}원</P>
                                    </Center>
                                </div>
                            </HorizontalFlex>
                        </div>
                    )}

                    <div className={style.machinesSection}>
                        <div className={style.sectionTitle}>키오스크</div>
                        <div className={style.deviceGrid}>
                            {kiosks.length > 0 ? (
                                kiosks.map((kiosk, index) => (
                                    <div key={index} className={style.deviceCard}>
                                        <div className={style.deviceHeader}>
                                            <FontAwesomeIcon fontSize={20} icon={fas["faTabletAlt"]} color={kiosk.heartbeat ? 'green' : 'red'} />
                                            <P size={20}>{kiosk.orderNo}</P>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className={style.emptyMessage}>
                                    <P size={15}>키오스크 데이터가 없습니다.</P>
                                </div>
                            )}
                        </div>

                        <div className={style.sectionTitle}>기기</div>
                        <div className={style.deviceGrid}>
                            {devices.length > 0 ? (
                                devices.map((device, index) => (
                                    <div key={device.id} className={style.deviceCard}>
                                        <div className={style.deviceHeader}>
                                            <FontAwesomeIcon fontSize={20} icon={fas["faBuilding"]} color={device.heartbeat ? 'green' : 'red'} />
                                            <P size={20}>{device.orderNo}</P>
                                        </div>
                                        <button onClick={() => handleManage(device)} className={style.manageButton}>관리</button>
                                    </div>
                                ))
                            ) : (
                                <div className={style.emptyMessage}>
                                    <P size={15}>머신 데이터가 없습니다.</P>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default StoreManagementDetail;